import { MediaResultEx } from '@euler/app/flows/media/types';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import type { Asset } from 'expo-media-library';
import { TouchableNativeFeedback, View } from 'react-native';
import { useMediaFilePicker } from './functions/useMediaFilePicker.web';

export const CameraScreen = wrapNavigatorScreen(
  (props: {
    photoOnly?: boolean;
    videoOnly?: boolean;
    multiple?: boolean;
    maxMediaCountToSelect?: number;
    mediaCaptureRequired?: boolean;
    onResult?: (result: MediaResultEx) => void;
    onMultipleAssetsSelected?: (assets: Asset[]) => void;
  }) => {
    const { onDismiss } = useMediaFilePicker({
      multiple: props.multiple,
      max: props.maxMediaCountToSelect,
      photoOnly: props.photoOnly,
      videoOnly: props.videoOnly,
      enabled: true,
      mediaCaptureRequired: props.mediaCaptureRequired,
      onSelected: async results => {
        if (props.multiple && results.length > 1) {
          const assets = results.map<Asset>((res, i) => ({
            id: `asset-${i}`,
            filename: res.filename ?? res.file.path.split('/').pop() ?? '',
            uri: res.uri,
            mediaType: res.type,
            width: res.type === 'photo' ? res.file.width : 0,
            height: res.type === 'photo' ? res.file.height : 0,
            creationTime: Date.now(),
            modificationTime: Date.now(),
            duration: 0,
          }));
          props.onMultipleAssetsSelected?.(assets);
        } else {
          results[0] && props.onResult?.(results[0]);
        }
      },
    });

    return (
      <TouchableNativeFeedback onPress={onDismiss}>
        <View
          css={`
            flex: 1;
          `}
        />
      </TouchableNativeFeedback>
    );
  },
  {
    animationEnabled: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
    detachPreviousScreen: false,
  },
);
